import gql from 'graphql-tag';
export const alertBannerNotificationsQuery = gql `
  query alertBannerNotifications($accountId: Int!) {
    isAuthenticated: isAuthenticatedV2

    currentUser: currentUserV2 {
      id
      bannerMessage
      hasSeenNotifications {
        jobsCta
      }
    }

    currentAccount: account(id: $accountId) {
      # Core account data
      id
      currency
      currentUserRole
      firstKnownUpgradeDate
      isUnlimited
      # Basic trialing data
      isTrialing
      trialEndDate
      # Teams data
      isTeamAccount
      isTrialingTeams
      teamAccountEndDate
      teamsTrialAutoUpgrade
      teamTrialEndDate
      # Companies data
      isCompanyAccount
      isTrialingCompanies
      companiesTrialEndDate
      # Current plan data
      plan: planV2 {
        id
        name
        interval
        isInPlanGroup
        amount
        type
      }
      # Offers issued to this account for Sunset campaign
      campaignOffers: campaignOffers(campaignSlug: "notion-discount") {
        id
        acceptedAt
        expiry
      }
    }

    possiblePlans: pricingPageV3Plans(accountId: $accountId) {
      planType
      plans {
        id
        name
        interval
        amount
        type
      }
    }

    # @ref ul-1: Professional* components expects interval to be year,
    # so be cognizant of that if changing.
    nextPlan: nextPlanV2(accountId: $accountId, interval: year) {
      id
      name
      interval
      amount
      type
    }

    nextTeamPlan: nextPlanV2(accountId: $accountId, type: "Team") {
      id
      name
      interval
      amount
      type
    }

    nextCompanyPlan: nextPlanV2(
      accountId: $accountId
      type: "Company"
      interval: year
    ) {
      id
      name
      interval
      amount
      type
    }
  }
`;
//# sourceMappingURL=alertBannerNotificationsQuery.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
